import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutTeaser from './components/AboutTeaser';
import WhyUsSection from './components/WhyUsSection';
import ContactBanner from './components/ContactBanner';

const SCHEMA = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': ['LocalBusiness', 'Organization'],
      '@id': `${import.meta.env.VITE_SITE_URL}/#organization`,
      name: 'MAX Sails Canada',
      url: import.meta.env.VITE_SITE_URL,
      logo: {
        '@type': 'ImageObject',
        url: `${import.meta.env.VITE_SITE_URL}/vite.svg`,
      },
      telephone: '+18193031365',
      email: 'contact@MAXSails.ca',
      address: {
        '@type': 'PostalAddress',
        addressRegion: 'QC',
        addressCountry: 'CA',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: '45.4765',
        longitude: '-75.7013',
      },
      areaServed: 'Worldwide',
      description:
        'MAX Sails Canada — quality sails at attractive prices. Custom sail making, sail repair and restoration. Serving sailors, sailing schools, clubs, hotels & resorts worldwide.',
      priceRange: '$$',
      knowsAbout: ['Custom Sail Making', 'Sail Repair', 'Mainsails', 'Headsails', 'Spinnakers', 'ILCA Sails', 'Laser Sails'],
      sameAs: [],
    },
    {
      '@type': 'WebSite',
      '@id': `${import.meta.env.VITE_SITE_URL}/#website`,
      url: import.meta.env.VITE_SITE_URL,
      name: 'MAX Sails Canada',
      inLanguage: ['en', 'fr'],
      publisher: { '@id': `${import.meta.env.VITE_SITE_URL}/#organization` },
    },
    {
      '@type': 'WebPage',
      '@id': `${import.meta.env.VITE_SITE_URL}/#webpage`,
      url: import.meta.env.VITE_SITE_URL,
      name: 'MAX Sails Canada | Quality Sails at Attractive Prices',
      description:
        'MAX Sails Canada — quality sails at attractive prices. Custom sail making, sail repair and restoration. Serving sailors, sailing schools, clubs, hotels & resorts worldwide.',
      inLanguage: ['en', 'fr'],
      isPartOf: { '@id': `${import.meta.env.VITE_SITE_URL}/#website` },
      about: { '@id': `${import.meta.env.VITE_SITE_URL}/#organization` },
      dateModified: '2026-04-09',
    },
    {
      '@type': 'FAQPage',
      '@id': `${import.meta.env.VITE_SITE_URL}/#faq`,
      mainEntity: [
        {
          '@type': 'Question',
          name: 'What types of sails does MAX Sails Canada make?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'MAX Sails Canada manufactures mainsails, headsails, spinnakers, cruising sails, and storm sails. We also offer custom lettering and numbering for racing sails and carry in-stock ILCA/Laser sails.',
          },
        },
        {
          '@type': 'Question',
          name: 'Does MAX Sails Canada ship worldwide?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Yes. MAX Sails Canada serves sailors, sailing schools, clubs, hotels and resorts worldwide with quality sails at attractive prices.',
          },
        },
        {
          '@type': 'Question',
          name: 'How do I request a custom sail quote?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'You can request a custom sail quote by filling out our contact form at maxsails.ca/contact or by calling +1 (819) 303-1365.',
          },
        },
      ],
    },
  ],
};

export default function HomePage() {
  useEffect(() => {
    const id = 'schema-home';
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(SCHEMA);
    return () => {
      const s = document.getElementById(id);
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        <AboutTeaser />
        <WhyUsSection />
        <ContactBanner />
      </main>
      <Footer />
    </div>
  );
}
